import React from 'react';
import {Login} from './container';

export const LoginScreen = () => {
  return <Login />;
};
